import { ReactNode } from "react";
import styles from "./styles/check_box.module.scss";

export const CheckBox = (props: {
  label: ReactNode;
  name?: string;
  value?: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: VoidFunction;
}) => {
  return (
    <>
      <div className={styles.wrapper}>
        <input
          className={styles.input}
          type="checkbox"
          name={props.name}
          value={props.value}
          required={props.required}
          disabled={props.disabled}
          onChange={props.onChange}
        />
        <label className={styles.label}>{props.label}</label>
      </div>
    </>
  );
};
